export default class MessageHandler {
    constructor(message, title = 'Error', type = 'error') {
        this.message = message;
        this.title = title;
        this.type = type;
    }
}